import { render, staticRenderFns } from "./WorkShiftDetailModal.vue?vue&type=template&id=15d38c42&"
import script from "./WorkShiftDetailModal.vue?vue&type=script&lang=js&"
export * from "./WorkShiftDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports